import {RefineProps} from "@refinedev/core";
import {dataProvider} from "./dataProvider";
import {notificationProvider} from "@refinedev/antd";
import routerBindings from "@refinedev/react-router-v6";

export const refineConfig = (url: string): RefineProps => {
    return {
        dataProvider: dataProvider(url),
        notificationProvider: notificationProvider,
        routerProvider: routerBindings,
        options: {
            syncWithLocation: true,
            warnWhenUnsavedChanges: true,
        }
    }
}

export default refineConfig;